import { render, staticRenderFns } from "./RacaCorCard.vue?vue&type=template&id=03f93084&scoped=true"
import script from "./RacaCorCard.vue?vue&type=script&lang=js"
export * from "./RacaCorCard.vue?vue&type=script&lang=js"
import style0 from "./RacaCorCard.vue?vue&type=style&index=0&id=03f93084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f93084",
  null
  
)

export default component.exports